import { Button } from "@/components/ui/button";

import { messageAnchor } from "../surface.tsx";

/**
 * Aviso junto al compositor mientras una tarjeta espera respuesta. No bloquea
 * la caja de texto: solo lleva a la tarjeta, que puede quedar lejos arriba.
 */
export function PendingNotice({ messageId }: { messageId: string }) {
  const goToCard = () => {
    document
      .getElementById(messageAnchor(messageId))
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div
      role="status"
      className="mb-2 flex items-center justify-between gap-3 rounded-lg border bg-card px-3.5 py-2 text-sm"
    >
      <span>Tienes algo esperando tu respuesta.</span>
      <Button type="button" variant="outline" size="sm" onClick={goToCard}>
        Ir a la tarjeta
      </Button>
    </div>
  );
}
